import React from "react";

interface Props {
  width?: number;
  height?: number;
  color?: string;
}

export function IconCopy(props: Props) {
  const { width = 32, height = 32, color = "#394150" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M19 13V8.33333C19 7.59695 18.403 7 17.6667 7H8.33333C7.59695 7 7 7.59695 7 8.33333V17.6667C7 18.403 7.59695 19 8.33333 19H13M23.6667 13H14.3333C13.597 13 13 13.597 13 14.3333V23.6667C13 24.403 13.597 25 14.3333 25H23.6667C24.403 25 25 24.403 25 23.6667V14.3333C25 13.597 24.403 13 23.6667 13Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}
